import { BasicLayout, BlankLayout } from '@/layout'

const storeRouter = {
  path: '/store',
  name: 'Store',
  component: BasicLayout,
  redirect: '/store/index',
  meta: { title: '本地商家管理', icon: 'el-icon-s-shop' },
  children: [
    {
      path: 'index',
      name: 'StoreList',
      meta: { title: '本地商家列表' },
      component: () => import('@/views/store/index')
    },
    {
      path: 'detail',
      name: 'StoreDetail',
      hidden: true,
      meta: { title: '商家详情', keepAlive: true, activeMenu: '/store/index' },
      component: () => import('@/views/store/detail')
    },
    {
      path: 'employee',
      name: 'StoreEmployee',
      meta: { title: '店员管理' },
      component: () => import('@/views/store/staff/index')
    },
    {
      path: 'goods',
      component: BlankLayout, // Parent router-view
      name: 'StoreGoods',
      meta: { title: '商品管理', breadcrumb: false },
      redirect: '/store/goods/index',
      children: [
        {
          path: 'index',
          name: 'StoreGoodList',
          meta: { title: '本地商家商品' },
          component: () => import('@/views/store/goods/list')
        },
        {
          path: 'detail',
          name: 'StoreGoodDetail',
          hidden: true,
          meta: { title: '商品详情', keepAlive: true, activeMenu: '/store/goods/index' },
          component: () => import('@/views/store/goods/detail')
        }
      ]
    },
    {
      path: 'order',
      name: 'StoreOrder',
      meta: { title: '本地商家订单' },
      component: () => import('@/views/store/order/index')
    }
  ]
}

export default storeRouter
